import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

export const useSendToHome = (isDeliveryOverride) => {
  const {deliveryLandingPage} = useSelector(state => state.session.features);
  const { isDelivery } = useSelector(state => state.basket);
  const navigate = useNavigate();
  if (!deliveryLandingPage && isDelivery) {
    return () => {
      window.location.href = 'https://pizzaexpress.com/delivery';
    };
  } else {
    return () => {
      navigate(isDelivery || isDeliveryOverride ? '/delivery' : '/collection');
    };
  }
};